/* --- src/widgets/SavingModal.jsx --- */
import { motion, AnimatePresence } from 'framer-motion'

export default function SavingModal({ open, message = 'กำลังดำเนินการ...' }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          key="saving-modal-bg z-[9999]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm"
        >
          <motion.div
            key="saving-modal-card"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 260, damping: 20 }}
            className="flex flex-col items-center gap-4 rounded-2xl bg-white px-8 py-6 shadow-xl sm:px-10"
          >
            <span className="inline-block h-10 w-10 animate-spin rounded-full border-4 border-primary/20 border-t-primary" />
            <p className="text-sm text-primary">{message}&nbsp;…</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
